import { Broker } from "~shapes/portfolio"
import { useQuery } from "react-query"
import { BrokerService } from "~services/BrokerService"
import { authorizedBrokers } from "~utils/broker"

const useUserBrokerConnections = (userId: string) => {
  return useQuery(
    ["user-broker-connections", userId],
    async () => {
      try {
        const v3Response: Broker[] =
          await BrokerService.getUserBrokerConnectionsV3(userId)
        return authorizedBrokers(v3Response)
      } catch (error) {
        return null
      }
    },
    {
      enabled: false,
      staleTime: 1000,
    }
  )
}

export default useUserBrokerConnections
